import mockNations from '../mockData/mockNations';
import { apiClient } from './apiClient';

class NationsService {
  constructor() {
    // Keine eigene Base-URL mehr nötig, wird über apiClient gesteuert
  }

  // Simuliert API-Verzögerung (kann später entfernt werden)
  async delay(ms = 100) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // Alle Nationen abrufen
  async getAllNations(filters = {}) {
    try {
      await this.delay();
      
      // Query-Parameter für Filter erstellen
      const queryParams = new URLSearchParams();
      if (filters.status) queryParams.append('status', filters.status);
      if (filters.region) queryParams.append('region', filters.region);
      
      const endpoint = `/nations${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const result = await apiClient.get(endpoint);
      
      return {
        success: true,
        data: result,
        total: Array.isArray(result) ? result.length : 0
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  }

  // Nation nach Code abrufen
  async getNationByCode(code) {
    try {
      await this.delay();
      
      // Suche nach Nation mit diesem Code
      const allNations = await this.getAllNations();
      if (!allNations.success) {
        throw new Error('Fehler beim Laden der Nationen');
      }
      
      const nation = allNations.data.find(n => n.code === code);
      
      if (!nation) {
        return {
          success: false,
          error: 'Nation nicht gefunden',
          data: null
        };
      }

      return {
        success: true,
        data: nation
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Nation nach ID abrufen
  async getNationById(id) {
    try {
      await this.delay();
      
      const result = await apiClient.get(`/nations/${id}`);
      
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Nationen nach Region abrufen
  async getNationsByRegion(region) {
    try {
      await this.delay();
      
      const result = await apiClient.get(`/nations/regions/${region}`);
      
      return {
        success: true,
        data: result,
        total: Array.isArray(result) ? result.length : 0
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  }

  // Nation-Status aktualisieren
  async updateNationStatus(nationId, status) {
    try {
      await this.delay();
      
      const result = await apiClient.put(`/nations/${nationId}/status`, { status });
      
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Teilnehmerstatistiken abrufen
  async getParticipantStats() {
    try {
      await this.delay();
      
      const result = await apiClient.get('/nations/stats/participants');
      
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Team-Verwaltung
  async getNationTeam(nationId) {
    try {
      await this.delay();
      const result = await apiClient.get(`/nations/${nationId}/team`);
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  async updateTeamParticipation(nationId, participatesInTeamCompetition) {
    try {
      await this.delay();
      const result = await apiClient.put(`/nations/${nationId}/team/participation`, {
        participatesInTeamCompetition
      });
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  async setTeamMembers(nationId, participantIds) {
    try {
      await this.delay();
      const result = await apiClient.put(`/nations/${nationId}/team/members`, {
        participantIds
      });
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  async getAvailableParticipants(nationId) {
    try {
      await this.delay();
      const result = await apiClient.get(`/nations/${nationId}/team/available-participants`);
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  }

  // Fallback auf Mock-Daten bei API-Fehlern
  async getMockNations() {
    const mockNations = [
      { id: 1, name: "Deutschland", code: "DE", participants: 25, status: "Bestätigt", region: "Europe" },
      { id: 2, name: "Schweiz", code: "CH", participants: 15, status: "Bestätigt", region: "Europe" },
      { id: 3, name: "China", code: "CN", participants: 56, status: "Bestätigt", region: "Asia" },
      { id: 4, name: "USA", code: "US", participants: 10, status: "Bestätigt", region: "America" },
      { id: 5, name: "Australien", code: "AU", participants: 15, status: "Bestätigt", region: "Oceania" }
    ];

    return {
      success: true,
      data: mockNations,
      total: mockNations.length
    };
  }
}

// Singleton-Instanz exportieren
const nationsService = new NationsService();
export default nationsService; 